import React from 'react';
import { X, Filter, Search } from 'lucide-react';

const FILTER_LABELS = {
  categoryFilter: 'Segmento',
  sourceFilter: 'Fonte',
  resultStateFilter: 'Estado',
  contactFilter: 'Contato',
};

const CONTACT_OPTIONS = [
  { value: 'telefone', label: 'Com telefone' },
  { value: 'whatsapp', label: 'Com WhatsApp' },
  { value: 'email', label: 'Com e-mail' },
];

export default function ResultsFilters({
  resultSearchInput, setResultSearchInput,
  categoryFilter, setCategoryFilter,
  sourceFilter, setSourceFilter,
  resultStateFilter, setResultStateFilter,
  contactFilter, setContactFilter,
  availableCategories, availableSources, availableResultStates,
}) {
  const activeFilters = [];
  if (categoryFilter && categoryFilter.length > 0) {
    categoryFilter.forEach((cat) => {
      activeFilters.push({ 
        key: `categoryFilter_${cat}`, 
        label: FILTER_LABELS.categoryFilter, 
        value: cat, 
        clear: () => setCategoryFilter(categoryFilter.filter(c => c !== cat)) 
      });
    });
  }
  if (sourceFilter !== 'all') activeFilters.push({ key: 'sourceFilter', label: FILTER_LABELS.sourceFilter, value: sourceFilter, clear: () => setSourceFilter('all') });
  if (resultStateFilter !== 'all') activeFilters.push({ key: 'resultStateFilter', label: FILTER_LABELS.resultStateFilter, value: resultStateFilter, clear: () => setResultStateFilter('all') });
  if (contactFilter !== 'all') {
    const cLabel = CONTACT_OPTIONS.find((o) => o.value === contactFilter)?.label || contactFilter;
    activeFilters.push({ key: 'contactFilter', label: FILTER_LABELS.contactFilter, value: cLabel, clear: () => setContactFilter('all') });
  }
  const hasSearch = resultSearchInput.trim().length > 0;
  const hasAnyFilter = activeFilters.length > 0 || hasSearch;

  const clearAll = () => {
    setCategoryFilter([]);
    setSourceFilter('all');
    setResultStateFilter('all');
    setContactFilter('all');
    setResultSearchInput('');
  };

  return (
    <div className="funnel-toolbar">
      {/* ── Search Bar ──────────────── */}
      <div className="funnel-search-wrap">
        <Search size={16} className="funnel-search-icon" />
        <input
          className="funnel-search-input"
          value={resultSearchInput}
          onChange={(e) => setResultSearchInput(e.target.value)}
          placeholder="Buscar por empresa, query, keyword ou categoria…"
        />
        {hasSearch && (
          <button className="funnel-search-clear" onClick={() => setResultSearchInput('')} title="Limpar busca">
            <X size={14} />
          </button>
        )}
      </div>

      {/* ── Filter Dropdowns Row ─────── */}
      <div className="funnel-selectors">
        <div className="funnel-select-group">
          <label className="funnel-select-label">Estado</label>
          <select value={resultStateFilter} onChange={(e) => setResultStateFilter(e.target.value)}>
            <option value="all">Todos</option>
            {availableResultStates.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        <div className="funnel-select-group">
          <label className="funnel-select-label">Segmento</label>
          <select 
            value="" 
            onChange={(e) => {
              const val = e.target.value;
              if (val === 'all') {
                setCategoryFilter([]);
              } else if (val) {
                if (!categoryFilter.includes(val)) {
                  setCategoryFilter([...categoryFilter, val]);
                }
              }
            }}
          >
            <option value="" disabled>Adicionar segmento...</option>
            <option value="all">Limpar Todos</option>
            {availableCategories.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
        </div>
        <div className="funnel-select-group">
          <label className="funnel-select-label">Fonte</label>
          <select value={sourceFilter} onChange={(e) => setSourceFilter(e.target.value)}>
            <option value="all">Todas</option>
            {availableSources.map((src) => (
              <option key={src} value={src}>{src}</option>
            ))}
          </select>
        </div>
        <div className="funnel-select-group">
          <label className="funnel-select-label">Contato</label>
          <select value={contactFilter} onChange={(e) => setContactFilter(e.target.value)}>
            <option value="all">Todos</option>
            {CONTACT_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
      </div>

      {/* ── Active Filter Trail ────── */}
      {hasAnyFilter && (
        <div className="funnel-active-bar">
          <div className="funnel-active-label">
            <Filter size={13} />
            <span>Filtros ativos</span>
          </div>
          <div className="funnel-active-tags">
            {hasSearch && (
              <>
                <span className="funnel-tag funnel-tag--search">
                  Busca: <strong>"{resultSearchInput.trim()}"</strong>
                  <button onClick={() => setResultSearchInput('')}><X size={11} /></button>
                </span>
                {activeFilters.length > 0 && <span className="funnel-connector">E</span>}
              </>
            )}
            {activeFilters.map((f, i) => (
              <React.Fragment key={f.key}>
                <span className="funnel-tag">
                  {f.label}: <strong>{f.value}</strong>
                  <button onClick={f.clear}><X size={11} /></button>
                </span>
                {i < activeFilters.length - 1 && <span className="funnel-connector">E</span>}
              </React.Fragment>
            ))}
          </div>
          <button className="funnel-clear-all" onClick={clearAll}>
            <X size={13} />
            Limpar tudo
          </button>
        </div>
      )}
    </div>
  );
}
